import React from 'react';
import CallHistoryComponent from '../../../Components/Agent/CallHistory';

export default function CallHistory() {
    return (
        <div className='page-body'>
            <CallHistoryComponent />
        </div>
    );
}